import initRelatedRecipesCarousel from './init-carousel';

import './style.scss';

const loadCarousel = () => {
	const blocks = document.querySelectorAll( '.wp-block-rte-related-recipes-carousel' );

	blocks.forEach( ( block ) => {
		block.querySelectorAll( '.rte-carousel' ).forEach( ( carousel ) => {
			initRelatedRecipesCarousel( carousel );
		} );
	} );
};

window.addEventListener( 'DOMContentLoaded', loadCarousel );
window.addEventListener( 'altisBlockContentChanged', loadCarousel );

if ( module.hot ) {
	module.hot.accept();
}
